import { unref } from 'vue'
import { RouteLocation } from 'vue-router'
import { auth0, loginWithRedirect } from '@/auth'

/**
 *
 * @param to
 */
export async function authenticationGuard(to: RouteLocation) {
  if (to.meta.unauthenticated) {
    // the loading screen shows on first-entry to application
    // this hides it when the first viewed page is one that doesn't require auth
    return true
  }

  const client = auth0()
  if (!unref(client.isAuthenticated)) {
    // Try to silently auth if we can
    await client.checkSession()
  }
  if (unref(client.isAuthenticated)) {
    return true
  }

  await loginWithRedirect(to.fullPath)
  // Block navigation while redirect is in flight
  return false
}

/**
 *
 * @param to
 */
export function pageTitleGuard(to: RouteLocation) {
  const prefix = 'Thyme Box'
  const title = to.meta.title ? String(to.meta.title) : null
  document.title = title ? `${prefix} - ${title}` : prefix
}
